/* eslint-disable react/prop-types */
import { makeStyles } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { useEffect, useState } from 'react';

const useStyles = makeStyles({
  wrapper: {
    position: 'relative',
    color: '#929292',
    display: 'flex',
    flexDirection: 'column',
    gap: '.8em',
  },
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    position: 'relative',
    color: '#929292',
    border: 'none',
    outline: 'none',
    fontSize: '1em',
    fontWeight: '600',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      opacity: 0.7,
    },
  },
  select: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    gap: '1.2em',
    width: 'auto',
    maxWidth: 'fit-content',
    backgroundColor: '#dee2e6',
    borderRadius: '1.2em',
    padding: '.4em 1em',
    cursor: 'pointer',
  },
  arrowDown: {
    display: 'flex',
    alignItems: 'center',
  },

  selectBox: {
    backgroundColor: '#dee2e6',
    borderRadius: '1.2em',
    padding: '1em',
    display: 'flex',
    flexDirection: 'column',
    gap: '.8em',
    animation: `$fadeIn .4s ease-in-out`,
  },
  option: {
    border: 'none',
    outline: 'none',
    color: '#929292',
    transition: 'all .4s ease-in-out',
    backgroundColor: 'inherit',
    borderRadius: '.8em',
    padding: '.4em',
    cursor: 'pointer',
    '&:hover': {
      opacity: '.6',
      backgroundColor: '#d0d2d4',
    },
    display: 'flex',
    flexDirection: 'column',
    gap: '.4em',
  },
  optionTitle: {
    color: '#000',
  },

  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
});

const SelectPerson = ({ handleChangePerson = (id) => {}, persons = [], value = null }) => {
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState({});

  const handleOpen = () => {
    setOpen(!open);
  };

  const handleSelectPerson = (person) => {
    setSelectedPerson(person);
    handleOpen();
    handleChangePerson(person?.id);
  };

  useEffect(() => {
    if (!value) return;

    const filteredPerson = persons?.find((person) => person?.id == value);

    setSelectedPerson(filteredPerson);
  }, [value]);

  return (
    <div className={classes.wrapper}>
      <button className={classes.root} type="button" onClick={handleOpen}>
        <div className={classes.select}>
          <div className={classes.name}>{selectedPerson?.name}</div>
          <div className={classes.arrowDown}>{open ? <ExpandLess /> : <ExpandMore />}</div>
        </div>
      </button>

      {open && (
        <div className={classes.selectBox}>
          {persons?.map((person) => (
            <button
              className={classes.option}
              type="button"
              onClick={(e) => {
                handleSelectPerson(person);
              }}>
              <div className={classes.optionTitle}>{person?.name}</div>
              <div>{person?.description}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectPerson;
